import {SubmitButton} from "../input/submitButton";
import React, {useEffect, useState} from "react";
import {useGlobalContext, useUserContext} from "../../hooks/globalContext";
import {InputText} from "../input/inputText";
import {TipTopPay} from "../../models/payments/tipTopPay";
import {ReactComponent as DeleteSVG} from '../../resourse/img/general/ic-trash.svg';
import {FormWithLoader} from "../loader/formWithLoader";
import {RouteNames} from "../../migration/pages";

export function TipTopPayPaymentModule() {
    const {i18n, api} = useGlobalContext()
    const {user} = useUserContext()
    const [tipTopPay, setTipTopPay] = useState<TipTopPay>({orgId: "", publicId: "", encryptedApiSecret: ""})
    const [apiSecret, setApiSecret] = useState<string>("")

    const [loading, setLoading] = useState<boolean>(false)
    const [encryptionLoading, setEncryptionLoading] = useState<boolean>(false)
    const [saveLoading, setSaveLoading] = useState<boolean>(false)
    useEffect(() => {
        const controller = new AbortController()
        if (user?.org) {
            api.getTipTopPaySettings({setLoading: setLoading, controller}, user?.org.id).then((res) => {
                if (res.data && user?.org?.id) {
                    setTipTopPay({
                        orgId: user?.org.id,
                        publicId: res.data?.publicId,
                        encryptedApiSecret: res.data?.encryptedApiSecret
                    })
                }
            })
        }
        return () => controller.abort()
    }, [user?.org])

    function encryptApiSecret() {
        api.encodePaymentKey({setLoading: setEncryptionLoading}, apiSecret).then((res) => {
            if (res.data) {
                setTipTopPay({...tipTopPay, encryptedApiSecret: res.data.encryptedSecretKey})
            }
        })
    }

    function onChangePublicId(v: string) {
        setTipTopPay({...tipTopPay, publicId: v})
    }

    function onRemoveEncryptionKey() {
        setTipTopPay({...tipTopPay, encryptedApiSecret: ""})
    }

    function onSave() {
        api.saveTipTopPaySettings({setLoading: setSaveLoading}, tipTopPay)
    }

    return (
        <FormWithLoader isloading={loading} className="form">
            <InputText label={i18n.api_key()} value={tipTopPay.publicId} onChange={onChangePublicId} isValidate={true}/>
            {tipTopPay.encryptedApiSecret === "" ?
                <InputText label={i18n.secret_key()} value={apiSecret} onChange={setApiSecret} isValidate={true}/>
                :
                <div className="control">
                    <label className="control__label">{i18n.encrypted_key()}</label>
                    <div className={"iiko_Tag"}>
                        <div className={"control__input"}
                             style={{
                                 display: "flex",
                                 alignItems: "center",
                                 textOverflow: "clip",
                                 overflow: "hidden"
                             }}>{tipTopPay.encryptedApiSecret}</div>
                        <DeleteSVG onClick={onRemoveEncryptionKey}/>
                    </div>
                </div>
            }
            <div className="form__buttons mt-4">
                <div className="form__buttons-left">
                    {tipTopPay.encryptedApiSecret === "" ?
                        <SubmitButton onSubmit={encryptApiSecret} label={i18n.encode()}
                                      disabled={false} isLoading={encryptionLoading}
                                      modal={true}/>
                        :
                        <SubmitButton onSubmit={onSave} label={i18n.save()}
                                      disabled={false} isLoading={saveLoading}
                                      modal={true}/>
                    }
                    <a href={RouteNames.SETTINGS} className="button -bordered_blue form__button">
                        {i18n.cancel()}
                    </a>
                </div>
            </div>
        </FormWithLoader>
    )
}
